import React, { useRef } from "react";
import { FONT, T, focusRing, prefersReducedMotion } from "./tokens";

// ===========================================================================
// VersionChip — one saved snapshot in the left rail.
//   • click / Enter          → restore this version to staging
//   • press-and-hold (~450ms) → open the before/after slider overlay
// FIFO capping (max 10) is handled by the parent; this is one chip.
// ===========================================================================

const HOLD_MS = 450;

export default function VersionChip({ version, active, onRestore, onCompareStart }) {
  const timer = useRef(null);
  const held = useRef(false);

  const startHold = () => {
    held.current = false;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      held.current = true;
      onCompareStart && onCompareStart(version);
    }, HOLD_MS);
  };
  const endHold = (fireClick) => {
    clearTimeout(timer.current);
    if (fireClick && !held.current) onRestore && onRestore(version);
    held.current = false;
  };

  return (
    <button
      type="button"
      aria-label={`Version ${version.label}${active ? " (current)" : ""} — click to restore, hold to compare`}
      title={`${version.label} · ${version.note || "snapshot"} — hold to compare`}
      onPointerDown={startHold}
      onPointerUp={() => endHold(true)}
      onPointerLeave={() => endHold(false)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onRestore && onRestore(version);
        }
      }}
      onFocus={(e) => (e.currentTarget.style.boxShadow = focusRing.boxShadow)}
      onBlur={(e) => (e.currentTarget.style.boxShadow = active ? `0 0 0 2px ${T.blue}` : "none")}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        height: 30,
        padding: "0 12px",
        borderRadius: T.radiusFull,
        border: `1px solid ${active ? T.blue : T.line}`,
        background: active ? T.blue : "rgba(255,255,255,0.7)",
        color: active ? "#fff" : T.ink2,
        fontFamily: FONT,
        fontSize: 12.5,
        fontWeight: 600,
        cursor: "pointer",
        boxShadow: active ? `0 0 0 2px ${T.blue}` : "none",
        transition: prefersReducedMotion()
          ? "none"
          : `transform var(--ds-dur-fast) ${T.ease}, background var(--ds-dur-fast) ${T.easeOut}`,
        touchAction: "none",
      }}
    >
      <span style={{ fontWeight: 700 }}>{version.label}</span>
    </button>
  );
}
